export default __webpack_public_path__ + "static/info-3ea44e3b9b28d2865c4def58c8fe9732.png";